import { createComparingLifecycle } from "./lifecycle";
export function onDidUpdate(callback) {
    return createComparingLifecycle("componentDidUpdateCallback", callback);
}
export default onDidUpdate;

//# sourceMappingURL=onDidUpdate.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/onDidUpdate.js
// module id = 59
// module chunks = 0